import { Paper, Stack, Typography, Box, Container, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { Droppable, Draggable } from 'react-beautiful-dnd';
import NegociosCard from './NegociosCard';
import DrawerNegocio from './DrawerNegocio';
import SkeletonKanbanCrm from 'src/components/skeleton/crm/SkeletonKanbanCrm';
import { setLeadData } from 'src/redux/slices/crm';

// actions
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import DrawerChatWhatsapp from 'src/sections/@chats/chat/DrawerChatWhatsapp';

/// silces
import { getChatInfoByChatId, getMensagensWhatsappDb, setChatInfo } from 'src/redux/slices/chat';

import { Card, CardContent } from 'src/@/components/ui/card';
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import { Input } from 'src/@/components/ui/input';

// ----------------------------------------------------------------------

KanbanColumn.propTypes = {
  column: PropTypes.object,
  index: PropTypes.number,
};

export default function KanbanColumn({
  user,
  configCrm,
  loadingKanban,
  cliente,
  column,
  index,
  callbackRefreshLeads,
  onSelect
}) {
  const dispatch = useDispatch();
  const { leadsKanban } = useSelector((state) => state.crm);
  const { nome, leadIds, id } = column;
  const [openDrawerChatWhatsapp, setOpenDrawerChatWhatsapp] = useState(false);

  // Estado para controlar o número de cards exibidos
  const [displayedCount, setDisplayedCount] = useState(10);

  // Estado para controlar a ordem do sort (decrescente ou crescente)
  const [isDescending, setIsDescending] = useState(true);

  // Estado para controlar o filtro de pesquisa
  const [searchTerm, setSearchTerm] = useState('');

  // Função para alternar a ordem do sort
  const toggleSortOrder = () => {
    setIsDescending((prev) => !prev);
  };

  // Filtra os leads com base no termo de pesquisa
  const filteredLeadIds = leadIds.filter((leadId) => {
    const lead = leadsKanban[leadId];
    return lead?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  // Ordena os IDs dos leads filtrados com base no campo `data_modificacao`
  const sortedLeadIds = [...filteredLeadIds].sort((a, b) => {
    const dateA = new Date(leadsKanban[a]?.data_modificacao || 0);
    const dateB = new Date(leadsKanban[b]?.data_modificacao || 0);
    return isDescending ? dateB - dateA : dateA - dateB;
  });

  // Calcula o valor total para os leads exibidos
  const totalValue = sortedLeadIds
    .slice(0, displayedCount)
    .reduce((sum, leadId) => {
      const lead = leadsKanban[leadId];
      return sum + (lead?.valor || 0);
    }, 0);

  // Função para carregar mais leads
  const handleLoadMore = () => {
    setDisplayedCount((prev) => Math.min(prev + 10, sortedLeadIds.length));
  };

  useEffect(() => {}, [leadsKanban, leadIds, isDescending, searchTerm]);

  async function handlOpenLead(data) {
    dispatch(setLeadData(data));
  }

  return (
    <>
      <DrawerChatWhatsapp
        open={openDrawerChatWhatsapp}
        onClose={() => {
          setOpenDrawerChatWhatsapp(false);
        }}
        cliente={cliente}
        user={user}
      />

      <Draggable isDragDisabled draggableId={id} index={index}>
        {(provided) => (
          <Card
            {...provided.draggableProps}
            ref={provided.innerRef}
            className="bg-slate-100 w-full"
          >
            <CardContent>
              <Stack spacing={3} {...provided.dragHandleProps}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                  sx={{ pt:0.5 }}
                >
                  <div>{nome}</div>
                  <p>
                    ({leadIds.length}) R$ {totalValue ? totalValue.toFixed(2) : 0}
                  </p>
                </Stack>

                {/* Linha com botão de ordenação e campo de pesquisa */}
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                  <Input
                    placeholder="Pesquisar"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="w-full h-6"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Button
                    onClick={toggleSortOrder}
                    variant="icon"
                    size="small"
                  >
                      <Iconify
                        icon={isDescending ? 'octicon:sort-asc-16' : 'octicon:sort-desc-16'}
                        width={20}
                        height={20}
                      />
                  </Button>
                </Stack>

                <Droppable droppableId={id} type="task">
                  {(provided) => (
                    <div
                      className="flex flex-col gap-2 w-full min-h-[70vh - 5vh] min-w-[240px]"
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {loadingKanban ? (
                        <SkeletonKanbanCrm />
                      ) : (
                        leadsKanban &&
                        sortedLeadIds
                          .slice(0, displayedCount) // Mostra apenas os leads limitados
                          .map((cardId, index) => (
                            <NegociosCard
                            callbackRefreshLeads={callbackRefreshLeads}
                              onOpenDrawerWhatsapp={(chatInfo, clienteWhatsapp) => {
                              }}
                              onOpen={() => {
                                onSelect(cardId);
                              }}
                              userId={user.id}
                              rules={user.rules}
                              key={index}
                              card={leadsKanban[cardId]}
                            />
                          ))
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                {/* Botão para carregar mais */}
                {displayedCount < sortedLeadIds.length && (
                  <Box textAlign="center" mt={2}>
                    <Button
                      className="bg-slate-200 text-slate-600 px-4 h-6 rounded"
                      onClick={handleLoadMore}
                    >
                      Carregar mais
                    </Button>
                  </Box>
                )}
              </Stack>
            </CardContent>
          </Card>
        )}
      </Draggable>
    </>
  );
}
